





























































































// vue
import { defineComponent, ref, onMounted } from '@vue/composition-api';

import { useService } from '@/vue3/api/services';
import { useNotify } from '@/vue3/hooks/notifyHook';


import InputSwitch from 'primevue/inputswitch';
import Dropdown from 'primevue/dropdown';
import Calendar from 'primevue/calendar';
import ProgressSpinner from 'primevue/progressspinner';

import GeoEditorTaskComments from '../misc/geoEditorTaskComments.vue';

export default defineComponent({
    components: {
        InputSwitch,
        Dropdown,
        Calendar,
        ProgressSpinner,
        GeoEditorTaskComments,
    },
    props: {
        geoRecord: {
            type: Object,
            default: () => {},
        },
        handleGeoRecordPropertyUpdate: {
            type: Function,
            default: () => {},
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
    },
    setup(props: any) {
        // reactive
        const accounts = ref();
        const selectedAccount = ref();
        const allStatusList = ref();
        const selectedStatus = ref();

        const isLoadingComment = ref<boolean>(false);

        const localGeoRecord = ref<any>(props.geoRecord)

        const comments = ref<any>([]); 

        // hooks
        const { getAllAccountByOrganization,
                getAllGeoRecordStatus,
                getGeoRecordCommentsByGeoRecordId,
                createGeoRecordComment,
                deleteGeoRecordComment
            } = useService();

        const { successToast, errorToast } = useNotify();

        // methods
        const onChangeIsTask = () => {
            if (!localGeoRecord.value.isTask) {
                localGeoRecord.value = props.handleGeoRecordPropertyUpdate({isTask: null, assigneeAccountId: null, startDate: null, dueDate: null, endDate: null});

                selectedAccount.value = null;
                selectedStatus.value = null;
            }
            else{
                localGeoRecord.value = props.handleGeoRecordPropertyUpdate({isTask: localGeoRecord.value.isTask});
            }
        };

        const onStatusChange = () => {
            if (selectedStatus.value === null) {
                localGeoRecord.value = props.handleGeoRecordPropertyUpdate({statusId: null})

                return;
            }
            if (selectedStatus.value) {
                localGeoRecord.value = props.handleGeoRecordPropertyUpdate({statusId: selectedStatus.value.id})
            }
        };

        const onAccountChange = (e) => {
            if (e.value === null) {
                localGeoRecord.value = props.handleGeoRecordPropertyUpdate({assigneeAccountId: null})
                return;
            }
            selectedAccount.value = e.value;
            accounts.value.forEach((account:any) => {
                if (account.name === e.value) {
                    localGeoRecord.value = props.handleGeoRecordPropertyUpdate({assigneeAccountId: account.id})
                }
            });
        };

        const getAllAccountDetails = async () => {
            accounts.value = await getAllAccountByOrganization();
            accounts.value.forEach((account:any) => {
                account.name = `${account.firstName} ${account.lastName}`;
            });
            accounts.value = accounts.value.filter((account:any) => {
                return account.name != ' ';
            });
            accounts.value = Object.values(
                accounts.value.reduce((c:any, e:any) => {
                    if (!c[e.name]) c[e.name] = e;
                    return c;
                }, {}),
            );
            if (localGeoRecord.value.assigneeAccountId !== undefined) {
                accounts.value.forEach((account) => {
                    if (account.id === localGeoRecord.value.assigneeAccountId) {
                        selectedAccount.value = account.name;
                    }
                });
            }
        };

        const getAllGeoRecordStatusDetails = async () => {
            allStatusList.value = await getAllGeoRecordStatus();
            allStatusList.value.forEach((status) => {
                status.name = status.name.toLowerCase();
            });
            if (
                localGeoRecord.value.isTask === true &&
                localGeoRecord.value.statusId !== undefined
            ) {
                allStatusList.value.forEach((status) => {
                    if (status.id === localGeoRecord.value.statusId) {
                        selectedStatus.value = status;
                    }
                });
            }
        };

        const getGeoRecordComments = async () => {
            isLoadingComment.value = true;
            comments.value = await getGeoRecordCommentsByGeoRecordId(props.geoRecord.id) || [];
            isLoadingComment.value = false;
        }


        const createGeoRecordCommentHandler = async (newComment:any) => {
            isLoadingComment.value = true;
            const res = await createGeoRecordComment(newComment);
            isLoadingComment.value = false;
            if(res == false){
                errorToast("Failed to add comment!")
                return false
            }
            else if (res == true) {
                await getGeoRecordComments();
                successToast("Successfully added the comment!")
                return true
            }
            else {
                comments.value = res;
                successToast("Successfully added the comment!")
                return true
            }
        }


        const deleteGeoRecordCommentHandler = async (id:number) => {
            isLoadingComment.value = true;
            const res = await deleteGeoRecordComment(id, props.geoRecord.id);
            isLoadingComment.value = false;
            if(res == false){
                errorToast("Failed to deleted comment!")
                return false
            }
            else if (res == true) {
                await getGeoRecordComments();
                successToast("Successfully deleted the comment!")
                return true
            }
            else {
                comments.value = res;
                successToast("Successfully deleted the comment!")
                return true
            }
        }

        // lifecycle
        onMounted(async () => {
            await getAllAccountDetails();
            await getAllGeoRecordStatusDetails();
            await getGeoRecordComments();
        });

        return {
            accounts,
            comments,
            localGeoRecord,
            onAccountChange,
            selectedAccount,
            allStatusList,
            onStatusChange,
            selectedStatus,
            onChangeIsTask,
            isLoadingComment,
            getGeoRecordComments,
            createGeoRecordCommentHandler,
            deleteGeoRecordCommentHandler,
        };
    },
});
